function isVisaExpirationDateValid(
  issueDate: Date | null | undefined,
  expirationDate: Date | null | undefined
): boolean {
  if (issueDate == null || expirationDate == null) {
    return false;
  }

  const issueDateCopy = new Date(issueDate);
  const maxDate = new Date(issueDateCopy.setUTCFullYear(issueDateCopy.getFullYear() + 20));

  if (expirationDate.getTime() > maxDate.getTime() || expirationDate.getTime() < new Date().getTime()) {
    return false;
  }

  return true;
}

export default isVisaExpirationDateValid;
